<template>
  <div>
    <DetailTemplate
      :customClass="'customer-detail detail-page'"
      v-if="getPermission('warranty:view')"
    >
      <template v-slot:sidebar-detail>
        <div>
          <template v-if="pageLoading">
            <v-skeleton-loader
              class="custom-skeleton height-30px custom-skeleton-full-width"
              width="100"
              type="text"
            >
            </v-skeleton-loader>
          </template>
          <template>
            <v-card class="h-100" elevation="0">
              <div class="d-flex align-center">
                <v-chip
                  :color="getColor(warrantyArr.status)"
                  label
                  v-if="warrantyArr.status"
                  class="mr-2"
                >
                  <span class="font-size-16 font-weight-500">
                    {{ getStatus(warrantyArr.status) }}
                  </span>
                </v-chip>
                <v-tooltip
                  right
                  content-class=""
                  v-if="warrantyArr?.extension_count > 0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar color="red" size="30" v-bind="attrs" v-on="on">
                      <span
                        class="white--text font-weight-700"
                        v-bind="attrs"
                        v-on="on"
                      >
                        E {{ warrantyArr.extension_count }}</span
                      >
                    </v-avatar>
                  </template>
                  <span> Extension </span>
                </v-tooltip>
                <!--  <v-chip
              v-if="
                warrantyArr &&
                warrantyArr.equipment &&
                warrantyArr.equipment.main_type == 'main_company'
              "
              label
              color="#0d47a1"
              outlined
              class="p-3 ml-2"
            >
              Own Asset
            </v-chip> -->
                <!--  <v-chip
              small
              label
              :color="
                get_equp_type_color(warrantyArr?.equipment?.equipemt_type)
              "
              text-color=""
              outlined
            >
              {{ get_equp_type(warrantyArr?.equipment?.equipemt_type) }}
            </v-chip> -->
              </div>
              <div class="px-2 py-5 customer-image text-center">
                <template>
                  <v-img
                    :lazy-src="$defaultImage"
                    :src="
                      warrantyArr &&
                      warrantyArr.equipment &&
                      warrantyArr.equipment.image
                        ? warrantyArr.equipment.image
                        : $defaultImage
                    "
                    aspect-ratio="1"
                    max-height="140"
                    max-width="140"
                    class="margin-auto custom-grey-border custom-border-radius-50"
                    transition="fade-transition"
                  >
                  </v-img>
                </template>
              </div>
              <div class="">
                <span
                  class="gray-background py-1 px-2 d-block color-custom-blue font-weight-700 font-size-16 text-uppercase"
                >
                  Warranty Detail
                </span>
                <table width="100%">
                  <tr>
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                      width="100"
                    >
                      Warranty #
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <v-chip
                        small
                        label
                        color="chip-custom-blue"
                        outlined
                        class="text-white p-3 mr-2"
                        text-color=""
                        v-if="warrantyArr && warrantyArr.unique_id"
                      >
                        {{ warrantyArr.unique_id }}
                      </v-chip>
                      <em v-else class="text--secondary"> no Warranty #</em>
                      <showBarcode
                        :barcodeUrl="
                          warrantyArr &&
                          warrantyArr.barcode_image &&
                          warrantyArr.barcode_image
                        "
                        :barcode-text="warrantyArr.unique_id"
                        title="Warranty Serial No"
                      ></showBarcode>
                    </td>
                  </tr>
                  <tr v-if="false">
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                      width="100"
                    >
                      Visit #
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <v-chip
                        small
                        label
                        color="chip-custom-blue"
                        outlined
                        class="text-white p-3 mr-2"
                        text-color=""
                        v-on:click="detailVisit(warrantyArr?.visit_id)"
                        v-if="warrantyArr && warrantyArr.visit_barcode"
                      >
                        {{ warrantyArr.visit_barcode }}
                      </v-chip>
                      <em v-else class="text--secondary"> no Visit #</em>
                    </td>
                  </tr>
                  <tr>
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                      width="100"
                    >
                      Reference No
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <span v-if="warrantyArr && warrantyArr.reference">
                        {{ warrantyArr.reference }}
                      </span>
                      <em v-else class="text--secondary"> no Reference No</em>
                    </td>
                  </tr>
                  <tr>
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                    >
                      Start Date
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <label
                        class="m-0"
                        v-if="warrantyArr && warrantyArr.start_date"
                      >
                        {{ formatDate(warrantyArr.start_date) }}
                      </label>
                      <em v-else class="text--secondary"> no start date </em>
                    </td>
                  </tr>
                  <tr>
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                    >
                      End Date
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <label
                        class="m-0"
                        v-if="warrantyArr && warrantyArr.end_date"
                      >
                        {{ formatDate(warrantyArr.end_date) }}
                      </label>
                      <em v-else class="text--secondary"> no end date </em>
                    </td>
                  </tr>

                  <tr>
                    <td class="font-size-18 font-weight-500 py-1" width="150">
                      Cost $
                    </td>
                    <td class="font-size-18 py-1">
                      <span v-if="warrantyArr && warrantyArr.cost">
                        <span class="text-capitalize"
                          >{{ formatMoney(warrantyArr.cost) }}
                        </span>
                      </span>
                      <em v-else class="text-muted">no cost price provided</em>
                    </td>
                  </tr>

                  <tr>
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                    >
                      Warranty period
                    </td>
                    <td valign="middle" class="py-2 font-size-18 color-red">
                      <label
                        class="m-0"
                        v-if="
                          warrantyArr &&
                          lodash.isEmpty(warrantyArr.duration) == false
                        "
                      >
                        {{ warrantyArr.duration }} ({{
                          warrantyArr.duration_type
                        }})
                      </label>
                      <em v-else class="text--secondary">
                        no warranty provided
                      </em>
                    </td>
                  </tr>
                  <tr v-if="warrantyArr && warrantyArr.end_date">
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                    >
                      Expiring on
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <label
                        class="m-0"
                        v-if="warrantyArr && warrantyArr.end_date"
                      >
                        {{ formatDate(warrantyArr.end_date) }}
                        <b class="font-weight-700"> midnight.</b>
                      </label>
                    </td>
                  </tr>
                  <tr v-if="warrantyArr && warrantyArr.end_date">
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                    >
                      Remaining
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <label
                        class="m-0"
                        v-if="warrantyArr && warrantyArr.end_date"
                      >
                        {{ remaningDate(warrantyArr) }}
                        <b>
                          <span style="color: red; font-weight: 700"
                            >({{ totalDays(warrantyArr) }} Days)</span
                          ></b
                        >
                      </label>
                    </td>
                  </tr>
                  <!-- <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Duration
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0"> 4(Days) </label>
                  </td>
                </tr> -->
                  <!-- <tr>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-600"
                  style="width: 140px"
                >
                  Description
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 d-flex"
                >
                  <label class="m-0" v-if="warrantyArr && warrantyArr.remark">
                    {{ warrantyArr.remark }}
                  </label>
                  <em v-else class="text--secondary"> no Description </em>
                </td>
              </tr> -->
                  <tr v-if="warrantyArr && warrantyArr.terminate_date">
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                    >
                      Terminate Date
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <label
                        class="m-0"
                        v-if="warrantyArr && warrantyArr.terminate_date"
                      >
                        {{ formatDate(warrantyArr.terminate_date) }}
                      </label>
                      <em v-else class="text--secondary"> no end date </em>
                    </td>
                  </tr>
                  <tr v-if="warrantyArr && warrantyArr.terminate_reason">
                    <td
                      valign="middle"
                      class="py-2 font-size-18 font-weight-500"
                      style="width: 41px"
                    >
                      Terminate Reason
                    </td>
                    <td valign="middle" class="py-2 font-size-18">
                      <label
                        class="m-0"
                        style="color: red !important"
                        v-if="warrantyArr && warrantyArr.terminate_reason"
                      >
                        {{ warrantyArr.terminate_reason }}
                      </label>
                      <em v-else class="text--secondary">
                        no Terminate Reason
                      </em>
                    </td>
                  </tr>
                </table>
              </div>
            </v-card>
          </template>
        </div>
      </template>
      <template v-slot:header-title>
        <div class="d-flex align-center">
          <template v-if="pageLoading">
            <v-skeleton-loader
              class="custom-skeleton height-40px custom-skeleton-full-width"
              width="600"
              type="text"
            >
            </v-skeleton-loader>
          </template>
          <template v-else>
            <h1
              class="form-title custom-nowrap-ellipsis text-capitalize mr-2 font-weight-700"
              v-if="
                warrantyArr &&
                warrantyArr.customer &&
                warrantyArr.customer.display_name
              "
            >
              {{ warrantyArr.customer.display_name }}
            </h1>
          </template>
          <!-- <v-chip
            label
            color="chip-custom-blue"
            outlined
            class="text-white p-3 mr-2"
            text-color=""
            style="font-size: 21px !important; font-weight: 700"
          >
            {{ warrantyArr.unique_id }}
          </v-chip> -->
          <!-- <v-chip
            :color="getColor(warrantyArr.status)"
            label
            v-if="warrantyArr.status"
          >
            <span class="font-size-16 font-weight-500">
              {{ getStatus(warrantyArr.status) }}
            </span>
          </v-chip>
          <v-chip
            v-if="
              warrantyArr &&
              warrantyArr.equipment &&
              warrantyArr.equipment.main_type == 'main_company'
            "
            label
            color="#0d47a1"
            outlined
            class="p-3 ml-2"
          >
            Own Equipment
          </v-chip> -->
        </div>
      </template>
      <template v-slot:header-action>
        <div class="d-flex align-center justify-end">
          <template
            v-if="
              false &&
              !warrantyArr.is_renewed &&
              warrantyArr.status != 1 &&
              warrantyArr.status != 4
            "
          >
            <v-tooltip bottom content-class="custom-bottom-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  :disabled="pageLoading"
                  class="mx-2 custom-bold-button white--text"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  v-on:click="getWarranty('renew')"
                >
                  <v-icon left>mdi-orbit-variant</v-icon> Renew
                </v-btn>
              </template>
              <span>Renew Warranty</span>
            </v-tooltip>
          </template>
          <template
            v-if="
              warrantyArr.status != 4 &&
              warrantyArr.status != 1 &&
              !warrantyArr.is_renewed
            "
          >
            <v-tooltip bottom content-class="custom-bottom-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  :disabled="pageLoading"
                  class="mx-2 custom-bold-button white--text"
                  color="orange"
                  v-bind="attrs"
                  v-on="on"
                  v-on:click="getWarranty('extend')"
                >
                  <v-icon left>mdi-update</v-icon> Extend
                </v-btn>
              </template>
              <span>Extend Warranty</span>
            </v-tooltip>
          </template>
          <template
            v-if="
              warrantyArr.status != 4 &&
              warrantyArr.status != 1 &&
              warrantyArr.status != 5
            "
          >
            <v-tooltip bottom content-class="custom-bottom-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  :disabled="pageLoading"
                  class="mx-2 custom-bold-button white--text"
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                  v-on:click="terminateWarranty"
                >
                  <v-icon left>mdi-update</v-icon> Terminate
                </v-btn>
              </template>
              <span>Terminate Warranty</span>
            </v-tooltip>
          </template>
          <v-btn
            depressed
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="goBack()"
          >
            <v-icon small left>mdi-keyboard-backspace</v-icon>
            Back
          </v-btn>
        </div>
      </template>
      <template v-slot:body>
        <v-row>
          <v-col md="6" v-if="false">
            <div class="new-white-box-overview-main nav">
              <div class="col-md-5 customer-image text-center">
                <v-skeleton-loader
                  class="custom-skeleton"
                  v-if="pageLoading"
                  type="image"
                >
                </v-skeleton-loader>
                <template v-else>
                  <v-img
                    :lazy-src="$defaultImage"
                    :src="
                      warrantyArr &&
                      warrantyArr.equipment &&
                      warrantyArr.equipment.image
                    "
                    aspect-ratio="1"
                    max-height="200"
                    max-width="200"
                    class="margin-auto custom-grey-border custom-border-radius-50"
                    transition="fade-transition"
                  >
                  </v-img>
                </template>
              </div>

              <div class="col-md-7 gray-background pt-0">
                <v-skeleton-loader
                  class="custom-skeleton"
                  v-if="pageLoading"
                  type="text@5"
                >
                </v-skeleton-loader>

                <table v-else class="width-100">
                  <span
                    class="color-custom-blue font-weight-700 font-size-19 mb-5"
                  >
                    Asset Detail
                    <div
                      v-if="warrantyArr && warrantyArr.equipment"
                      class="d-flex"
                    >
                      <v-chip
                        label
                        :color="
                          warrantyArr.equipment.main_type == 'main_customer'
                            ? '#4CAF50'
                            : '#0D47A1'
                        "
                        class="text-white p-3 mb-1"
                        small
                      >
                        <template
                          v-if="
                            warrantyArr.equipment.main_type == 'main_customer'
                          "
                        >
                          Customer
                        </template>
                        <template v-else> Company </template>
                      </v-chip>
                      <v-chip
                        label
                        :color="
                          warrantyArr.equipment.type == 'personal'
                            ? 'cyan'
                            : 'red'
                        "
                        outlined
                        small
                        class="text-white p-3 mr-3"
                      >
                        <template
                          v-if="warrantyArr.equipment.type == 'personal'"
                        >
                          Customer/Own
                        </template>
                        <template v-else> {{ appCompanyName }} </template>
                      </v-chip>
                    </div>
                  </span>
                  <template>
                    <tr>
                      <td
                        class="pb-2 font-size-18 text-capitalize"
                        style="width: 160px"
                      >
                        Asset Name
                      </td>
                      <td
                        class="pb-2 font-size-18 font-weight-600 text-capitalize"
                      >
                        <span
                          class="fw-500 no-wrap"
                          v-if="
                            warrantyArr &&
                            warrantyArr.equipment &&
                            warrantyArr.equipment.name
                          "
                        >
                          {{ warrantyArr.equipment.name }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pb-2 font-size-18 text-capitalize">
                        Serial no
                      </td>
                      <!--   <pre>{{ customer }}</pre> -->
                      <td
                        class="pb-2 font-size-18 font-weight-600 text-capitalize"
                        v-if="
                          warrantyArr &&
                          warrantyArr.equipment &&
                          warrantyArr.equipment.serial_no
                        "
                      >
                        {{ warrantyArr.equipment.serial_no }}
                      </td>
                      <em v-else class="text-muted"> no Serial no</em>
                    </tr>
                    <tr>
                      <td class="pb-2 font-size-18 text-capitalize">Model</td>
                      <td
                        class="pb-2 font-size-18 font-weight-600 text-capitalize"
                        v-if="
                          warrantyArr &&
                          warrantyArr.equipment &&
                          warrantyArr.equipment.model
                        "
                      >
                        <span class="fw-500 no-wrap">
                          {{ warrantyArr.equipment.model }}
                        </span>
                      </td>
                      <em v-else class="text-muted"> no model</em>
                    </tr>
                    <tr>
                      <td class="pb-2 font-size-18 text-capitalize">Brand</td>
                      <!--   <pre>{{ customer }}</pre> -->
                      <td
                        class="pb-2 font-size-18 font-weight-600 text-capitalize"
                        v-if="
                          warrantyArr &&
                          warrantyArr.equipment &&
                          warrantyArr.equipment.brand &&
                          warrantyArr.equipment.brand
                        "
                      >
                        {{ warrantyArr.equipment.brand }}
                      </td>
                      <em v-else class="text-muted"> no Brand</em>
                    </tr>
                    <tr>
                      <td class="pb-2 font-size-18 text-capitalize">
                        Location
                      </td>
                      <!--   <pre>{{ customer }}</pre> -->
                      <td
                        class="pb-2 font-size-18 font-weight-600 text-capitalize"
                        v-if="
                          warrantyArr &&
                          warrantyArr.equipment &&
                          warrantyArr.equipment.location &&
                          warrantyArr.equipment.location.text
                        "
                      >
                        {{ warrantyArr.equipment.location.text }}
                      </td>
                      <em v-else class="text-muted"> no Location</em>
                    </tr>
                  </template>
                </table>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-tabs
          active-class="custom-tab-active"
          v-model="contractTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent tab-sticky"
        >
          <v-tab class="font-size-16 font-weight-600 px-8" href="#overview">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/overview.svg')" />
              <!--end::Svg Icon-->
            </span>
            Overview
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#extension">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/product.svg')" />
              <!--end::Svg Icon-->
            </span>
            Extension
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#attachment">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
              <!--end::Svg Icon-->
            </span>
            Attachment
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#history">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/history.svg')" />
            </span>
            History
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="contractTab">
          <v-tab-item value="attachment">
            <AdditionalDocuments
              :type-id="warrantyArr.id"
              class="mx-4"
              type-text="Warranty Attachments"
              :type="115"
              :extensive="false"
            ></AdditionalDocuments>
          </v-tab-item>
          <v-tab-item value="overview">
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll"
              style="height: calc(100vh - 160px); position: relative"
            >
              <div class="" v-if="!pageLoading">
                <v-row>
                  <!-- Left Column: Asset / Equipment Details & Remarks -->
                  <v-col cols="12" md="6">
                    <!-- Asset / Equipment Card -->
                    <v-card outlined elevation="0">
                      <div
                        class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                      >
                        <div class="d-flex align-center">
                          <v-icon class="mr-2" color="blue darken-2" small
                            >mdi-cube-outline</v-icon
                          >
                          <div>
                            <h3
                              class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                            >
                              {{ equipmentLabel }} Details
                            </h3>
                          </div>
                        </div>
                        <v-chip
                          v-if="
                            warrantyArr &&
                            warrantyItem &&
                            warrantyItem.barcode
                          "
                          color="blue darken-2"
                          label
                          small
                          outlined
                          class="font-weight-600 cursor-pointer"
                          @click="detailWarrantyItem(warrantyItem)"
                        >
                          {{ warrantyItem.barcode }}
                        </v-chip>
                      </div>

                      <v-card-text class="px-4">
                        <div class="erp-info-grid">
                          <div
                            class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                          >
                            <span class="font-size-18 font-weight-500">
                              {{ equipmentLabel }} #
                            </span>
                            <div
                              class="erp-value d-flex align-center font-size-18"
                            >
                              <v-chip
                                v-if="
                                  warrantyArr &&
                                  warrantyItem &&
                                  warrantyItem.barcode
                                "
                                small
                                label
                                color="chip-custom-blue"
                                outlined
                                class="mr-2 font-weight-600"
                                @click="
                                  detailWarrantyItem(warrantyItem)
                                "
                              >
                                {{ warrantyItem.barcode }}
                              </v-chip>
                              <em v-else class="text--secondary font-size-16"
                                >No {{ equipmentLabel }} #</em
                              >
                              <showBarcode
                                v-if="warrantyItem"
                                :barcodeUrl="warrantyItem.barcode_image"
                                :title="`${equipmentLabel} Barcode`"
                              />
                            </div>
                          </div>

                          <div
                            class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                          >
                            <span class="font-size-18 font-weight-500">
                              Name
                            </span>
                            <span
                              class="erp-value font-size-18 font-weight-500 text--primary"
                            >
                              <template
                                v-if="
                                  warrantyArr &&
                                  warrantyItem &&
                                  warrantyItem.name
                                "
                              >
                                {{ warrantyItem.name }}
                              </template>
                              <em v-else class="text--secondary font-size-16"
                                >no name</em
                              >
                            </span>
                          </div>

                          <div
                            class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                          >
                            <span class="font-size-18 font-weight-500">
                              {{ equipmentLabel }} Serial No.
                            </span>
                            <div
                              class="erp-value d-flex align-center font-size-18"
                            >
                              <template
                                v-if="
                                  warrantyArr &&
                                  warrantyItem &&
                                  warrantyItem.serial_no
                                "
                              >
                                <v-chip
                                  color="blue darken-4"
                                  outlined
                                  label
                                  small
                                  class="mr-2 font-weight-600"
                                >
                                  {{ warrantyItem.serial_no }}
                                </v-chip>
                                <showBarcode
                                  :barcodeUrl="
                                    warrantyItem.serial_image
                                  "
                                  :barcode-text="
                                    warrantyItem.serial_no
                                  "
                                  :title="`${equipmentLabel} Serial No`"
                                />
                              </template>
                              <template v-else>
                                <em class="text--secondary font-size-16"
                                  >no {{ equipmentLabel }} Serial No.</em
                                >
                              </template>
                            </div>
                          </div>

                          <div
                            class="erp-info-row d-flex align-center justify-space-between py-2"
                          >
                            <span class="font-size-18 font-weight-500">
                              Selling Price
                            </span>
                            <div class="erp-value font-size-18">
                              <template
                                v-if="
                                  warrantyArr &&
                                  warrantyItem &&
                                  warrantyItem.selling_price
                                "
                              >
                                <v-chip
                                  outlined
                                  label
                                  small
                                  color="blue"
                                  class="font-weight-600"
                                >
                                  {{
                                    formatMoney(
                                      warrantyItem.selling_price
                                    )
                                  }}
                                </v-chip>
                              </template>
                              <template v-else>
                                <em class="text--secondary font-size-16"
                                  >no Selling Price</em
                                >
                              </template>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Right Column: Customer Details, Contact & Site Location -->
                  <v-col
                    cols="12"
                    md="6"
                    v-if="
                      warrantyArr &&
                      warrantyArr.equipemt_type !== 'parts' &&
                      warrantyArr.equipment &&
                      warrantyArr.equipment.main_type == 'main_customer'
                    "
                  >
                    <!-- Customer / Entity Profile Card -->
                    <v-card outlined elevation="0">
                      <div
                        class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                      >
                        <div class="d-flex align-center">
                          <v-icon class="mr-2" color="indigo darken-2" small
                            >mdi-account-tie-outline</v-icon
                          >
                          <div>
                            <h3
                              class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                            >
                              <template
                                v-if="
                                  warrantyArr &&
                                  warrantyArr.equipment &&
                                  warrantyArr.equipment.main_type ==
                                    'main_customer'
                                "
                              >
                                Customer Detail
                              </template>
                              <template v-else>
                                <template
                                  v-if="warrantyArr && warrantyArr.entity"
                                  >Site Location</template
                                >
                              </template>
                            </h3>
                          </div>
                        </div>
                      </div>

                      <v-card-text class="px-4">
                        <template
                          v-if="
                            warrantyArr &&
                            warrantyArr.equipment &&
                            warrantyArr.equipment.main_type == 'main_customer'
                          "
                        >
                          <div class="erp-info-grid">
                            <div
                              class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                            >
                              <span class="font-size-18 font-weight-500"
                                >Type</span
                              >
                              <div class="erp-value font-size-18">
                                <template v-if="warrantyArr.equipment.customer">
                                  <v-chip
                                    v-if="
                                      warrantyArr.equipment.customer
                                        .company_type == 'company'
                                    "
                                    color="blue"
                                    label
                                    small
                                    outlined
                                    class="font-weight-500 text-uppercase"
                                  >
                                    Company
                                  </v-chip>
                                  <v-chip
                                    v-else-if="
                                      warrantyArr.equipment.customer
                                        .company_type == 'personal'
                                    "
                                    color="red"
                                    label
                                    small
                                    outlined
                                    class="font-weight-500"
                                  >
                                    Individual
                                  </v-chip>
                                </template>
                              </div>
                            </div>

                            <div
                              class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                            >
                              <span class="font-size-18 font-weight-500"
                                >Display Name</span
                              >
                              <div class="erp-value font-size-18">
                                <router-link
                                  v-if="
                                    warrantyArr.equipment.customer &&
                                    warrantyArr.equipment.customer.display_name
                                  "
                                  class="font-size-18 custom-link"
                                  :to="`/admin/customer/detail/${warrantyArr.equipment.customer.id}`"
                                >
                                  {{
                                    warrantyArr.equipment.customer.display_name
                                  }}
                                </router-link>
                                <em v-else class="text-muted font-size-16"
                                  >no Display Name</em
                                >
                              </div>
                            </div>

                            <template
                              v-if="
                                warrantyArr.equipment.customer &&
                                warrantyArr.equipment.customer.company_type ==
                                  'company'
                              "
                            >
                              <div
                                class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                              >
                                <span class="font-size-18 font-weight-500"
                                  >Company Name</span
                                >
                                <span
                                  v-if="warrantyArr.equipment.customer.company_name"
                                  class="erp-value font-size-18 text--primary"
                                >
                                  {{ warrantyArr.equipment.customer.company_name }}
                                </span>
                                <em v-else class="text-muted">no Company Name</em>
                              </div>

                              <div
                                class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                              >
                                <span class="font-size-18 font-weight-500"
                                  >Company Email</span
                                >
                                <span
                                  v-if="warrantyArr.equipment.customer.company_email"
                                  class="erp-value font-size-18 text--primary"
                                >
                                  {{ warrantyArr.equipment.customer.company_email }}
                                </span>
                                <em v-else class="text-muted">no Company Email</em>
                              </div>

                              <div
                                class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                              >
                                <span class="font-size-18 font-weight-500"
                                  >Company Number</span
                                >
                                <span
                                  v-if="warrantyArr.equipment.customer.company_number"
                                  class="erp-value font-size-18 text--primary"
                                >
                                  {{ warrantyArr.equipment.customer.company_number }}
                                </span>
                                <em v-else class="text-muted">no Company Number</em>
                              </div>

                              <div
                                class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                              >
                                <span class="font-size-18 font-weight-500"
                                  >Company Fax</span
                                >
                                <span
                                  v-if="warrantyArr.equipment.customer.company_fax"
                                  class="erp-value font-size-18 text--primary"
                                >
                                  {{ warrantyArr.equipment.customer.company_fax }}
                                </span>
                                <em v-else class="text-muted">no Company Fax</em>
                              </div>

                              <div
                                class="erp-info-row d-flex align-center justify-space-between py-2 border-bottom-dashed"
                              >
                                <span class="font-size-18 font-weight-500"
                                  >UEN</span
                                >
                                <span
                                  v-if="warrantyArr.equipment.customer.uen"
                                  class="erp-value font-size-18 text--primary"
                                >
                                  {{ warrantyArr.equipment.customer.uen }}
                                </span>
                                <em v-else class="text-muted">no UEN</em>
                              </div>

                              <div
                                class="erp-info-row d-flex align-center justify-space-between py-2"
                              >
                                <span class="font-size-18 font-weight-500"
                                  >Website</span
                                >
                                <span
                                  v-if="warrantyArr.equipment.customer.website"
                                  class="erp-value font-size-18 text--primary"
                                >
                                  {{ warrantyArr.equipment.customer.website }}
                                </span>
                                <em v-else class="text-muted">no Website</em>
                              </div>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            v-if="warrantyArr && warrantyArr.entity"
                            class="py-2 font-size-18 font-weight-700 text--primary"
                          >
                            {{ getFormattedCompany() }}
                          </div>
                          <div v-else class="font-size-16 text--secondary">
                            no details
                          </div>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <!-- Contact & Address Grid -->
                  <template
                    v-if="
                      warrantyArr &&
                      warrantyArr.equipemt_type !== 'parts' &&
                      warrantyArr.equipment &&
                      warrantyArr.equipment.main_type == 'main_customer'
                    "
                  >
                    <!-- Primary Contact & Company Address -->
                    <v-col cols="12" sm="6" class="d-flex flex-column">
                      <v-card
                        class="bg-slate-50 h-100 border-slate"
                        outlined
                        flat
                      >
                        <div
                          class="d-flex align-center pa-3 grey lighten-5 custom-border-bottom"
                        >
                          <v-icon color="cyan darken-2" small class="mr-2"
                            >mdi-card-account-phone-outline</v-icon
                          >
                          <span
                            class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                            >Contact Details</span
                          >
                        </div>

                        <v-card-text class="pa-3">
                          <!-- Contact Person Info -->
                          <div class="mb-3">
                            <div
                              class="font-size-12 font-weight-700 color-custom-blue mb-1"
                            >
                              Primary Contact
                            </div>
                            <template
                              v-if="
                                warrantyArr.equipment.property &&
                                warrantyArr.equipment.property.contact_person
                              "
                            >
                              <div
                                class="d-flex align-center font-size-12 text-slate-800 py-1"
                                v-if="
                                  warrantyArr.equipment.property.contact_person
                                    .display_name
                                "
                              >
                                <v-icon small color="slate-600" class="mr-2"
                                  >mdi-account-outline</v-icon
                                >
                                <span class="font-weight-600">{{
                                  warrantyArr.equipment.property.contact_person
                                    .display_name
                                }}</span>
                              </div>
                              <div
                                class="d-flex align-center font-size-12 text-slate-600 py-1"
                                v-if="
                                  warrantyArr.equipment.property.contact_person
                                    .primary_phone
                                "
                              >
                                <v-icon small color="slate-500" class="mr-2"
                                  >mdi-phone-outline</v-icon
                                >
                                <span>{{
                                  warrantyArr.equipment.property.contact_person
                                    .primary_phone
                                }}</span>
                              </div>
                              <div
                                class="d-flex align-center font-size-12 text-slate-600 py-1"
                                v-if="
                                  warrantyArr.equipment.property.contact_person
                                    .primary_email
                                "
                              >
                                <v-icon small color="slate-500" class="mr-2"
                                  >mdi-email-outline</v-icon
                                >
                                <span class="word-wrap-fix">{{
                                  warrantyArr.equipment.property.contact_person
                                    .primary_email
                                }}</span>
                              </div>
                            </template>
                            <em
                              v-else
                              class="text-muted font-italic font-size-12"
                              >no primary contact</em
                            >
                          </div>

                          <div class="custom-border-bottom pt-1 mb-3"></div>

                          <!-- Company Address Info -->
                          <div>
                            <div
                              class="font-size-12 font-weight-700 color-custom-blue mb-1"
                            >
                              Company Address
                            </div>
                            <template v-if="warrantyArr.equipment.property">
                              <div
                                class="d-flex align-start font-size-12 text-slate-700"
                              >
                                <v-icon
                                  small
                                  color="slate-500"
                                  class="mr-2 mt-1"
                                  >mdi-map-marker-outline</v-icon
                                >
                                <div class="address-text">
                                  <span
                                    v-if="
                                      warrantyArr.equipment.property.street_1
                                    "
                                    >{{
                                      warrantyArr.equipment.property.street_1
                                    }},<br
                                  /></span>
                                  <span
                                    v-if="
                                      warrantyArr.equipment.property.street_2
                                    "
                                    >{{
                                      warrantyArr.equipment.property.street_2
                                    }},
                                  </span>
                                  <span
                                    v-if="
                                      warrantyArr.equipment.property.unit_no
                                    "
                                    >{{
                                      warrantyArr.equipment.property.unit_no
                                    }},<br
                                  /></span>
                                  <span
                                    >{{
                                      warrantyArr.equipment.property.country
                                    }},
                                    {{
                                      warrantyArr.equipment.property.zip_code
                                    }}</span
                                  >
                                </div>
                              </div>
                            </template>
                            <em
                              v-else
                              class="text-muted font-italic font-size-12"
                              >no company address</em
                            >
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <!-- Site Location Contact & Address -->
                    <v-col cols="12" sm="6" class="d-flex flex-column">
                      <v-card
                        class="bg-slate-50 h-100 border-slate"
                        outlined
                        flat
                      >
                        <div
                          class="d-flex align-center px-3 py-3 grey lighten-5 custom-border-bottom"
                        >
                          <v-icon color="cyan darken-2" small class="mr-2"
                            >mdi-map-marker-radius-outline</v-icon
                          >
                          <span
                            class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                            >Site Location Details</span
                          >
                        </div>
                        <v-card-text class="pa-3">
                          <!-- Site Contact Person -->
                          <div class="mb-3">
                            <div
                              class="font-size-12 font-weight-700 color-custom-blue mb-1"
                            >
                              Site Contact
                            </div>
                            <div
                              class="d-flex align-center font-size-12 text-slate-800 py-1"
                              v-if="warrantyArr.location_person_display_name"
                            >
                              <v-icon small color="slate-600" class="mr-2"
                                >mdi-account-outline</v-icon
                              >
                              <span class="font-weight-600">{{
                                warrantyArr.location_person_display_name
                              }}</span>
                            </div>
                            <div
                              class="d-flex align-center font-size-12 text-slate-600 py-1"
                              v-if="warrantyArr.location_person_primary_phone"
                            >
                              <v-icon small color="slate-500" class="mr-2"
                                >mdi-phone-outline</v-icon
                              >
                              <span>{{
                                warrantyArr.location_person_primary_phone
                              }}</span>
                            </div>
                            <div
                              class="d-flex align-center font-size-12 text-slate-600 py-1"
                              v-if="warrantyArr.location_person_primary_email"
                            >
                              <v-icon small color="slate-500" class="mr-2"
                                >mdi-email-outline</v-icon
                              >
                              <span class="word-wrap-fix">{{
                                warrantyArr.location_person_primary_email
                              }}</span>
                            </div>
                            <em
                              v-if="
                                !warrantyArr.location_person_display_name &&
                                !warrantyArr.location_person_primary_phone &&
                                !warrantyArr.location_person_primary_email
                              "
                              class="text-muted font-italic font-size-12"
                            >
                              no site contact
                            </em>
                          </div>

                          <div class="custom-border-bottom pt-1 mb-3"></div>

                          <!-- Site Location Address -->
                          <div>
                            <div
                              class="font-size-12 font-weight-700 color-custom-blue mb-1"
                            >
                              Site Location Company Address
                            </div>
                            <div
                              class="d-flex align-start font-size-12 text-slate-700"
                              v-if="warrantyArr"
                            >
                              <v-icon small color="slate-500" class="mr-2 mt-1"
                                >mdi-map-marker-outline</v-icon
                              >
                              <div class="address-text">
                                <span
                                  v-if="warrantyArr.location_property_name"
                                  class="d-block font-weight-600"
                                  >{{
                                    warrantyArr.location_property_name
                                  }}</span
                                >
                                <span v-if="warrantyArr.location_street_1"
                                  >{{ warrantyArr.location_street_1 }},<br
                                /></span>
                                <span v-if="warrantyArr.location_street_2"
                                  >{{ warrantyArr.location_street_2 }},
                                </span>
                                <span v-if="warrantyArr.location_unit_no"
                                  >{{ warrantyArr.location_unit_no }},<br
                                /></span>
                                <span
                                  >{{ warrantyArr.location_country }},
                                  {{ warrantyArr.location_zip_code }}</span
                                >
                              </div>
                            </div>
                            <em
                              v-else
                              class="text-muted font-italic font-size-12"
                              >no site address</em
                            >
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </template>
                  <v-col cols="12" md="12">
                    <!-- Description / Remarks Card -->
                    <v-card class="" outlined elevation="0">
                      <div
                        class="grey lighten-5 d-flex align-center px-4 py-3 border-bottom"
                      >
                        <v-icon class="mr-2" color="amber darken-3" small
                          >mdi-text-box-outline</v-icon
                        >
                        <div>
                          <h3
                            class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                          >
                            Description
                          </h3>
                        </div>
                      </div>
                      <v-card-text class="pa-4">
                        <div
                          v-if="warrantyArr && warrantyArr.remark"
                          class="remark-box pa-3 rounded grey lighten-5 border-left-accent word-wrap-fix font-size-16 text--primary"
                        >
                          {{ warrantyArr.remark }}
                        </div>
                        <div
                          v-else
                          class="text-center py-4 grey lighten-5 rounded border-dashed"
                        >
                          <em class="text--secondary font-size-16"
                            >no Description</em
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="pa-4">
                <v-skeleton-loader type="card, article"></v-skeleton-loader>
              </div>
            </perfect-scrollbar>
          </v-tab-item>
          <v-tab-item :value="'extension'">
            <ExtensionLog
              :key="extensionLogKey"
              :related-id="warrantyArr.id"
            ></ExtensionLog>
          </v-tab-item>
          <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <div class="service-detail-search-height">
              <InternalHistoryDetail
                type="warranty"
                :type_id="warrantyArr.id"
              ></InternalHistoryDetail>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </template>
      <template v-slot:footer> </template>
    </DetailTemplate>
    <ExtentWarranty
      v-if="extentWarrantyDialog"
      :warrantyDetail="warrantyArr"
      :dialogStatus="extentWarrantyDialog"
      @success="onWarrantyExtended"
      v-on:close:dialog="extentWarrantyDialog = false"
      v-on:update:warranty="getWarranty"
    >
    </ExtentWarranty>
    <RenewWarranty
      v-if="renewWarrantyDialog"
      :warrantyDetail="warrantyArr"
      @success="getWarranty"
      :dialogStatus="renewWarrantyDialog"
      v-on:close:dialog="renewWarrantyDialog = false"
      v-on:update:warranty="getWarranty"
    ></RenewWarranty>
    <TerminatWarranty
      v-if="teminateWarrantyDialog"
      :warrantyDetail="warrantyArr"
      @success="getWarranty"
      :dialogStatus="teminateWarrantyDialog"
      v-on:close:dialog="teminateWarrantyDialog = false"
      v-on:update:warranty="getWarranty"
    ></TerminatWarranty>
  </div>
</template>
<script>
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { GET /* , PATCH */ } from "@/core/services/store/request.module";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
import ExtentWarranty from "@/view/pages/warranty/Extended-Warranty.vue";
import RenewWarranty from "@/view/pages/warranty/Renew-Warranty.vue";
import ExtensionLog from "@/view/pages/warranty/Extension-Log.vue";
import TerminatWarranty from "@/view/pages/warranty/Terminat-Warranty.vue";
import moment from "moment";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import showBarcode from "@/view/components/showBarcode.vue";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "customer-detail",
  title: "Customer",
  data() {
    return {
      pageLoading: false,
      contractTab: "overview",
      warranty: 0,
      extentWarrantyDialog: false,
      renewWarrantyDialog: false,
      teminateWarrantyDialog: false,
      warrantyArr: {},
      extensionLogKey: 0,
    };
  },
  components: {
    DetailTemplate,
    AdditionalDocuments,
    showBarcode,
    ExtentWarranty,
    RenewWarranty,
    TerminatWarranty,
    InternalHistoryDetail,
    ExtensionLog,
  },
  computed: {
    warrantyItem() {
      if (this.warrantyArr?.equipemt_type === "parts") {
        return {
          ...this.warrantyArr?.product,
          serial_no: this.warrantyArr?.product?.serial_number,
          selling_price: this.warrantyArr?.product?.sale_price,
        };
      }

      return this.warrantyArr?.equipment;
    },
    equipmentLabel() {
      const type = this.warrantyArr?.equipemt_type;
      if (type === "asset") return "Asset";
      if (type === "customer-asset") return "Equipment";
      if (type === "parts") return "Parts";
      return "Equipment";
    },
  },

  methods: {
    detailVisit(id) {
      this.$router.push(
        this.getDefaultRoute("visit.detail", {
          params: { id: id },
        })
      );
    },
    goBack() {
      this.$router.push(
        this.getDefaultRoute("warranty", {
          params: {},
        })
      );
    },
    get_equp_type(type) {
      if (type == "asset") {
        return "Own Asset";
      } else if (type == "customer-asset") {
        return "Customer Asset";
      } else if (type == "tool") {
        return "Tool";
      } else {
        return "Customer Asset";
      }
    },
    get_equp_type_color(type) {
      if (type == "asset") {
        return "red";
      } else if (type == "customer-asset") {
        return "blue";
      } else if (type == "tool") {
        return "green";
      } else {
        return "green";
      }
    },
    terminateWarranty() {
      this.teminateWarrantyDialog = true;
    },
    getStatusColor(status = "") {
      let color = "cyan";
      switch (status) {
        case "Active":
          color = "green";
          break;
        case "In-Active":
          color = "red";
          break;
        case "Faulty":
          color = "orange";
          break;
        case "Retired":
          color = "red";
          break;
      }
      return color;
    },

    viewEquipment(params, id) {
      console.log(params);

      let routeName = null;
      if (params == "customer-asset") {
        routeName = "client-equipment.detail";
      } else if (params == "asset") {
        routeName = "client-equipment.detail";
      }

      this.$router.push(
        this.getDefaultRoute(routeName, {
          params: { id: id },
        })
      );
    },
    remaningDate(date) {
      var a = moment(date.end_date);
      var b = moment(date.start_date);

      var years = a.diff(b, "year");
      b.add(years, "years");

      var months = a.diff(b, "months");
      b.add(months, "months");

      var days = a.diff(b, "days");
      if (days == 0) {
        days = "";
      } else {
        days = days + " Days";
      }
      if (months == 0) {
        months = "";
      } else {
        months = months + " Months";
      }
      if (years == 0) {
        years = "";
      } else {
        years = years + " Years";
      }

      return years + " " + months + " " + days;
    },
    getFormattedCompany() {
      let tempArr = [];
      if (this.warrantyArr.entity.unit_no) {
        tempArr.push(this.warrantyArr.entity.unit_no);
      }
      if (this.warrantyArr.entity.street_1) {
        tempArr.push(this.warrantyArr.entity.street_1);
      }
      if (this.warrantyArr.entity.street_2) {
        tempArr.push(this.warrantyArr.entity.street_2);
      }

      if (this.warrantyArr.entity.zip_code) {
        tempArr.push(this.warrantyArr.entity.zip_code);
      }
      if (this.warrantyArr.entity.landmark) {
        tempArr.push(this.warrantyArr.entity.landmark);
      } else {
        tempArr.push("Singapore");
      }
      /*   if (this.lodash.isEmpty(row.city) === false) {
        tempArr.push(row.city.name);
      }
      if (this.lodash.isEmpty(row.state) === false) {
        tempArr.push(row.state.name);
      }
      if (this.lodash.isEmpty(row.country) === false) {
        tempArr.push(row.country);
      } */
      return tempArr.join(", ");
    },
    /*   totalDays(date) {
      var a = moment(date.end_date);
      var b = moment(date.start_date);
      var final = a.diff(b, "days"); // =1
      return final;
    }, */
    totalDays(date) {
      let today = moment().format("YYYY-MM-DD");

      var a = moment(date.end_date);
      var b = moment(today); //date.start_date
      var final = a.diff(b, "days"); // =1
      if (final <= 0) {
        final = 0;
      }
      return final;
    },
    getStatus(status) {
      if (status == 1) {
        return "Draft";
      } else if (status == 2) {
        return "Active";
      } else if (status == 3) {
        return "Extended";
      } else if (status == 4) {
        return "Terminated";
      } else if (status == 5) {
        return "Expired";
      } else if (status == 6) {
        return "Renewed";
      }
    },
    detailEquipmint(param) {
      this.$router.push(
        this.getDefaultRoute("client-equipment.detail", {
          params: {
            id: param,
          },
        })
      );
    },
    detailWarrantyItem(item) {
      const equipmentType = this.warrantyArr?.equipemt_type;
      if (equipmentType === "parts") {
        this.$router.push(
          this.getDefaultRoute("part.detail", {
            params: { id: item.id },
          })
        );
        return;
      }
      if (equipmentType === "asset") {
        this.$router.push(
          this.getDefaultRoute("asset-equipment.detail", {
            params: { id: item.id },
          })
        );
        return;
      }

      this.detailEquipmint(item.id);
    },
    getColor(status) {
      if (status == 1) {
        return "cyan white--text";
      } else if (status == 2) {
        return "green white--text";
      } else if (status == 3) {
        return "orange white--text";
      } else if (status == 4) {
        return "red white--text";
      } else if (status == 5) {
        return "teal white--text";
      } else if (status == 6) {
        return "blue white--text";
      }
    },
    getWarranty(type) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "warranty/" + _this.warranty,
        })
        .then(({ data }) => {
          _this.warrantyArr = data;
          if (type && type == "extend") {
            this.extentWarrantyDialog = true;
          }
          if (type && type == "renew") {
            this.renewWarrantyDialog = true;
          }
          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Warranty", route: "warranty" },
            { title: "Detail" },
            { title: data.barcode },
          ]);
          _this.pageLoading = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    onWarrantyExtended() {
      this.getWarranty();
      this.extensionLogKey += 1;
    },
  },
  mounted() {
    if (this.warranty > 0) {
      this.getWarranty();
    }
  },
  created() {
    const _this = this;
    _this.warranty = _this.lodash.toSafeInteger(_this.$route.params.id);
  },
};
</script>
<style scoped>
.word-wrap-fix {
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
}
.border-bottom-dashed {
  border-bottom: 1px dashed #e2e8f0;
}

.border-left-accent {
  border-left: 4px solid #f59e0b !important;
}

.border-dashed {
  border: 1px dashed #cbd5e1 !important;
}

.custom-link {
  color: #2563eb !important;
  text-decoration: none;
}

.custom-link:hover {
  text-decoration: underline;
}

.address-text {
  line-height: 1.5;
  color: #334155;
}
</style>
